module.exports = __webpack_public_path__ + "static/img/1.de4a55c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Chengtun/1.jpg
// module id = rgUl
// module chunks = 0